import { MAXIMUM_NUMBER_OF_RESULTS_PER_SECTION as o } from "./help-center-articles-search19.js";
import { getIndexName as i, algoliaSearchClient as g } from "./help-center-articles-search21.js";
const u = {
  clickAnalytics: !0,
  attributesToRetrieve: ["objectID", "title", "landingUrl"],
  attributesToHighlight: ["title"],
  ruleContexts: [],
  getRankingInfo: !0,
  hitsPerPage: o
}, P = async (e) => {
  const { query: t, environment: r, locale: s, querySuggestionSearchParameters: a } = e, n = {
    requests: [
      {
        indexName: i(s, r),
        query: t,
        ...a ?? u
      }
    ]
  };
  return await g.search(n);
};
export {
  P as getSuggestedQueries
};
//# sourceMappingURL=help-center-articles-search24.js.map
